import React, { useState } from 'react';
import { Divider } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { translate } from '@portal/services/i18n';

import Certificate from '@portal/assets/svg/onboarding-icons/ic_certificate.svg?react';
import Correct from '@portal/assets/svg/onboarding-icons/ic_correct.svg?react';

import OnboardingUserPhotoModal from '../OnboardingUserPhotoModal/OnboardingUserPhotoModal';
import { validateOnboardingDocument } from '@portal/utils/validate';
import { onboarding } from '@portal/config/app.json';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface IProps {
  setFileSelected: (value: File) => void;
}

const OnboardingRegisterSituationDocument = ({ setFileSelected }: IProps) => {
  const [modal, setModal] = useState(false);
  const [fileSelectedModal, setFileSelectedModal] = useState(null);
  const onFileChange = (e) => {
    if (
      e.target.files[0]?.type !== 'image/png' &&
      e.target.files[0]?.type !== 'application/pdf' &&
      e.target.files[0]?.type !== 'image/jpeg'
    ) {
      return;
    }

    if (!validateOnboardingDocument(e)) {
      return;
    }

    setFileSelected(e.target.files[0]);
    setFileSelectedModal(e.target.files[0]);
  };

  return (
    <>
      <div className="action-display" onClick={() => setModal(true)}>
        <div className="action-display__action">
          <div className="action-display__action__options">
            <Certificate
              width={25}
              height={25}
              className="action-display__action__options__icon"
            />
            <div className="action-display__action__options__container">
              <ThemedText
                variant="body"
                className="action-display__action__options__title-document"
              >
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_CADASTRAL_SITUATION_DOCUMENT.TITLE'
                )}
              </ThemedText>
              <ThemedText
                variant="body"
                className="action-display__action__options__text"
              >
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_CADASTRAL_SITUATION_DOCUMENT.LABEL'
                )}
              </ThemedText>
            </div>
          </div>
          <ThemedText>
            {fileSelectedModal ? (
              <Correct width={25} height={25} />
            ) : (
              <RightOutlined
                style={{
                  color: 'black',
                  fontSize: 20,
                }}
              />
            )}
          </ThemedText>
        </div>
        <Divider />
      </div>
      {modal ? (
        <OnboardingUserPhotoModal
          onCancel={() => setModal(false)}
          onFileChange={onFileChange}
          visible={modal}
          fileSelected={fileSelectedModal}
          title={translate(
            'PAGES.AUTH.REGISTER.ONBOARD.PF.ONBOARDING_CADASTRAL_SITUATION_DOCUMENT.MODAL_TITLE'
          )}
          accept={`image/png, image/jpeg, ${
            onboarding.acceptPdfDocs ? 'application/pdf' : ''
          }`}
          sendType="document"
        />
      ) : null}
    </>
  );
};

export default OnboardingRegisterSituationDocument;
